import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { MessageService } from '../../services/message.service';
import { Subscription } from 'rxjs';
import { PartnerService } from 'src/app/services/partner.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    host: { 'class': 'login main-screen' },
    standalone: false
})
export class LoginComponent implements OnInit {
    registerForm: UntypedFormGroup;
    submitted = false;
    emailFocus = false;
    passwordFocus = false;
    serverError: any = '';
    notice = '';
    token;
    emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
    form: UntypedFormGroup;
    message: any;
    subscription: Subscription;
    ssoProviders: Array<{ slug: string; display_name: string }> = [
        { slug: 'adp', display_name: 'ADP' }
    ];

    constructor(
        private authS: AuthService,
        private fb: UntypedFormBuilder,
        private router: Router,
        private actRoute: ActivatedRoute,
        private userSer: UserService,
        private partnerSer: PartnerService,
        private msg: MessageService
    ) {
        if (this.authS.isLoggedIn() && false ) {
            this.router.navigate(['/dashboard']);
        }

        this.subscription = this.msg.getMessage().subscribe(message => { this.message = message; });
    }

    ngOnInit() {
        if (sessionStorage.getItem('password_changed')) {
            sessionStorage.removeItem('password_changed');
            this.notice = 'Your password was changed. Please sign in with the new password.';
        }
        this.registerForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.minLength(6)]],
            check: ''
        });

        this.actRoute.queryParams.subscribe(params => {
            if (params['sso_error']) {
                this.serverError = this.authS.ssoErrorMessage(params['sso_error']);
            }
        });

        this.authS.getSsoProviders().subscribe((res: any) => {
            if (res && res.data && res.data.length) {
                this.ssoProviders = res.data.filter((provider: any) => {
                    return provider.slug === 'adp' || provider.configured;
                });
            }
        }, () => {
            this.ssoProviders = [{ slug: 'adp', display_name: 'ADP' }];
        });
    }


    // convenience getter for easy access to form fields
    get f() { return this.registerForm.controls; }

    onSubmit() {
        this.registerForm.controls.email.setValue((this.registerForm.value.email || '').trim());

        // stop here if form is invalid
        if (this.registerForm.invalid) {
            this.submitted = true;
            return;
        } else {
            this.authS.getLogin(this.registerForm.value.email, this.registerForm.value.password).subscribe((data: any) => {
                if (data.status) {
                    this.authS.persistSession(data);
                    this.router.navigate(['/dashboard']);
                } else {
                    this.serverError = data.error;
                }
            });
        }

    }

  autofocus(text) {
      if (text === 'email') {
        this.emailFocus = true;
        this.passwordFocus = false;
      } else {
        this.passwordFocus = true;
        this.emailFocus = false;
      }
  }

  loginWithSso(slug: string) {
      window.location.href = this.authS.ssoStartUrl(slug);
  }

    /*
     ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.subscription.unsubscribe();
    }
    */
}

